import AllgemeineParameter from './AllgemeineParameter';
export default AllgemeineParameter;
